export const SUPPORTED_TYPES = {
  JPEG: 'image/jpeg' as 'image/jpeg',
  GIF: 'image/gif' as 'image/gif',
  PNG: 'image/png' as 'image/png',
  MP4: 'video/mp4' as 'video/mp4',
  PDF: 'application/pdf' as 'application/pdf',
};